import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import HelpArticleLink from '../../../../../components/help-article-link';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';

import style from './style.module.less';

export const HelpSection = ({ articleId = undefined, description, href = undefined, icon, isHelpArticleLink = false, onClick, title }) => {
  return (
    <FlexRow className={style['help-section']}>
      <FontAwesomeIcon className={style.icon} icon={icon} />
      <FlexColumn>
        {isHelpArticleLink && (
          <HelpArticleLink articleId={articleId} className={style.title} onClick={onClick}>
            <Text textType={TextType.Label} value={title} />
          </HelpArticleLink>
        )}
        {!isHelpArticleLink && (
          <Button href={href} onClick={onClick} theme='link'>
            <Text textType={TextType.Label} value={title} />
          </Button>
        )}
        <Text className={style.description} textType={TextType.Caption} value={description} />
      </FlexColumn>
    </FlexRow>
  );
};

HelpSection.propTypes = {
  articleId: PropTypes.string,
  description: MessageDescriptorPropType.isRequired,
  href: PropTypes.string,
  icon: PropTypes.object.isRequired,
  isHelpArticleLink: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  title: MessageDescriptorPropType.isRequired,
};
